module.exports = __webpack_public_path__ + "img/step4-mobile-en@2x.1a2144c0.webp";